import { render, staticRenderFns } from "./AbpWindow.vue?vue&type=template&id=b81ceed8&scoped=true&"
import script from "./AbpWindow.vue?vue&type=script&lang=ts&"
export * from "./AbpWindow.vue?vue&type=script&lang=ts&"
import style0 from "./AbpWindow.vue?vue&type=style&index=0&id=b81ceed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81ceed8",
  null
  
)

export default component.exports